import * as React from 'react'

import { LoginForm, LoginFormSSO } from 'main/components/common/AuthModal'
import { CredentialsFields } from 'main/gql/credentials'
import { Flags, useFeatureFlag } from 'main/hooks/useFeatureFlag'
import { Text } from 'main/ui'

import { SchoolContainer, SchoolType } from '../../types'
import { TextContainer } from './Login.styles'

interface IProps {
  schoolContainer: SchoolContainer
  onRequestSignUp: () => void
  onComplete: (credentials: CredentialsFields) => void
}

export default function Login(props: IProps) {
  const { schoolContainer, onRequestSignUp, onComplete } = props

  const ssoFlag = useFeatureFlag(Flags.SSO)
  const isSSO = ssoFlag.enabled()

  if (isSSO) {
    return (
      <div>
        <LoginFormSSO />
      </div>
    )
  } else {
    return (
      <div>
        <TextContainer>
          <Text>{getSubtext(schoolContainer)}</Text>
        </TextContainer>

        <LoginForm
          cta={getFormSubmitButtonCta(schoolContainer)}
          onComplete={onComplete}
          onRequestSignUp={onRequestSignUp}
        />
      </div>
    )
  }
}

export function getSubtext(schoolContainer: SchoolContainer) {
  switch (schoolContainer.__type) {
    case SchoolType.Internal:
      return 'Please provide your contact information to the director'
    case SchoolType.External:
      return 'Please provide your contact information'
  }
}

export function getFormSubmitButtonCta(schoolContainer: SchoolContainer) {
  switch (schoolContainer.__type) {
    case SchoolType.Internal:
      return 'Next: Write your message'
    case SchoolType.External:
      return 'Next: Tell us about your needs'
  }
}
